module.exports = __webpack_public_path__ + "static/media/Bisharp_gaussian2.34ed3269.png";